<template>
  <div class="w-full py-6 border-b border-gray-300 flex justify-between
  items-center px-6">
    <a :href="media.url" target="_blank" v-if="openable">{{ media.description }}</a>
    <span v-else class="flex w-full justify-center">{{ media.description }}</span>
    <button v-if="editing" @click="$emit('delete')" class="hover:text-beige-academy-300">
      <bin-icon class="w-4" />
    </button>
  </div>
</template>

<script>
import BinIcon from '../graphics/BinIcon.vue';

export default {
  components: { BinIcon },
  props: ['media', 'editing', 'openable'],
};
</script>
